import { Resource } from 'beisheim/models'

class Folder extends Resource {
  static entity = 'Folder'
  static baseEntity = 'Resource'

  get countries () {
    return Resource.query().whereIdIn(this.children_ids).get()
  }

  get locales () {
    const languages = this.countries.map(c => c.children)
    return languages
  }
}

Resource.addModel(Folder)

export { Folder }
export default Folder
